import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import IconButton from '@mui/material/IconButton'
import useMediaQuery from '@mui/material/useMediaQuery'
import Logo  from '../../components/Logo'
import { useTheme } from '@mui/material/styles'
import { Menu, Close } from '@mui/icons-material'
import { Button, Stack } from '@mui/material'

const Header = () => {
  const [visibleMenu, setVisibleMenu] = useState(false)
  const { breakpoints } = useTheme()
  const matchMobileView = useMediaQuery(breakpoints.down('md'))

  const navItems = [
    { label: 'Features', href: '#feature' },
    { label: 'Reviews', href: '#testimonial' },
    { label: 'Blog', href: 'https://blog.voicetyping.xyz/' },
    { label: 'Help', href: '/dashboard/help' },
  ]

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 'appBar',
        backgroundColor: 'rgba(255,255,255,0.86)',
        backdropFilter: 'blur(16px)',
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container sx={{ py: { xs: 2, md: 3 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Logo />
          <Box sx={{ ml: 'auto', display: { xs: 'inline-flex', md: 'none' } }}>
            <IconButton onClick={() => setVisibleMenu(!visibleMenu)}>
              <Menu />
            </IconButton>
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', md: 'row' },

              transition: (theme) => theme.transitions.create(['top']),
              ...(matchMobileView && {
                py: 6,
                backgroundColor: 'background.paper',
                zIndex: 'appBar',
                position: 'fixed',
                height: { xs: '100vh', md: 'auto' },
                top: visibleMenu ? 0 : '-120vh',
                left: 0,
              }),
            }}
          >
            <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" spacing={3}>
              {navItems.map((item) => (
                <Button key={item.label} color="inherit" href={item.href} sx={{ fontWeight: 700 }}>
                  {item.label}
                </Button>
              ))}
            </Stack>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5} sx={{ mt: { xs: 4, md: 0 } }}>
              <Button href="/login" variant="outlined">
                Sign in
              </Button>
              <Button href="/login" variant="contained" color="primary">
                Start free
              </Button>
            </Stack>
            {visibleMenu && matchMobileView && (
              <IconButton
                sx={{
                  position: 'fixed',
                  top: 10,
                  right: 10,
                }}
                onClick={() => setVisibleMenu(!visibleMenu)}
              >
                <Close />
              </IconButton>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Header
